import {useSelector} from 'react-redux'

export const useFavoriteEvents = ()=>{
	const workouts = useSelector(state=>state.programEvents.workouts)
	const tasks = useSelector(state=>state.programEvents.tasks)
	const nutrition = useSelector(state=>state.programEvents.nutrition)
	return {workouts,tasks,nutrition}
}